<template>
  <div class="pecipeList">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="药房">
        <DicInput @fieldId="fieldId($event,'pharmacyId')" :initName="searchForm.pharmacyId"  :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="设备类型">
        <DicInput @fieldId="fieldId($event,'deviceId')" :initName="searchForm.deviceId" :dicType="1"></DicInput>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker
            @input="search"
            v-model="searchForm.loginTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div class="flex">
      <div style="flex: 1">
        <div ref="mis4" style="width:100%;height:650px;"></div>
      </div>
      <div style="flex: 1">
        <div style="border: 1px solid #c9cdd6">
          <el-table
              :header-cell-style="{background:'#F5F5F5'}"
              :data="tableData"
              style="width: 100%;min-height: 600px"
          >
            <el-table-column
                prop="createTime"
                align="center"
                label="创建时间">
            </el-table-column>
            <el-table-column
                prop="operatorName"
                label="代理商">
            </el-table-column>
            <el-table-column
                prop="pharmacyName"
                label="药房">
            </el-table-column>
            <el-table-column
                prop="deviceTypeName"
                label="设备型号">
            </el-table-column>
            <el-table-column
                prop="maintainBy"
                label="保养人">
            </el-table-column>
            <el-table-column
                prop="maintainLevel"
                align="center"
                width="140"
                label="维护评价分">
              <template slot-scope="scope">
                <el-rate
                    v-model="scope.row.maintainLevel"
                    disabled
                    show-score
                    text-color="#ff9900">
                </el-rate>
              </template>
            </el-table-column>
            <el-table-column
                prop="evaluateNote"
                align="center"
                label="维护评价内容">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 20px">
          <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                      @handleCurrentChange='handleCurrentChange'></Pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import {pickerOptions} from '@/service/common'
import DicInput from "@/components/DicInput";
import echarts from 'echarts/lib/echarts'
// // 再引入你需要使用的图表类型，标题，提示信息等
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/aria'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
export default {
  name: "pecipeList",
  data() {
    return {
      pickerOptions:pickerOptions,
      tableData: [],
      srcList: [],
      doctor_count: '',
      searchForm: {
        start:'',
        end:'',
        loginTime:[],
        deviceType:'',
        operatorId:'',
        pharmacyId:'',
        deviceId:'',
        exceptionType:'',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      dialogVisible: false,
      doctorDetails: '',
      rstart:'',
      rend:'',
    }
  },
  components: {
    Pagination,
    DicInput
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
      this.tableData=[]
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        start:'',
        end:'',
        loginTime:[],
        deviceType:'',
        operatorId:'',
        pharmacyId:'',
        deviceId:'',
        exceptionType:'',
      }
      this.init()
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.list()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.list()
    },
    echarts(data) {
      let mis4 = echarts.init(this.$refs.mis4);
          mis4.setOption(
          {
            tooltip: {
              trigger: 'item',
            },
            legend: {
              top:100
            },
            series: [
              {
                name: '保养评价分布',
                type: 'pie',
                radius: '50%',
                data: data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
      )
      mis4.off('click')
      mis4.on('click',(e)=>{
          this.rstart=e.data.range[0]
          this.rend=e.data.range[1]
          this.list()
      })
    },
    // list
    list(){
      let data={
        ...this.searchForm,
        start:this.searchForm.loginTime[0],
        end:this.searchForm.loginTime[1],
        Status:'2',
        rstart:this.rstart,
        rend:this.rend,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("/api/MaintainTask", {params: data}).then((res) => {
        this.tableData=res.list
        this.tableData.forEach(item=>{
          item.maintainLevel=item.maintainLevel/20
          item.createTime = this.dayjs(item.createTime).format('YYYY/MM/DD')
        })
        this.total=res.totalPage
      })
    },
    init() {
      let data = {
        ...this.searchForm,
        start:this.searchForm.loginTime[0],
        end:this.searchForm.loginTime[1],

      }
      delete data.loginTime
      this.axios
          .get("/Statistics/MaintainStatistic/MaintainEvaluateStatistic",{params: data})
          .then((res) => {
            this.echarts(res)
          })
    }
  },
  mounted() {
    //
    this.init()
    this.echarts()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }
  .decBox{
    padding-right: 20px;
    i{
      font-style: normal;
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>